import type { JSX, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useLearner } from '../state/LearnerContext.tsx';

/** Sends a visitor without a profile to the sign-up flow, remembering where they were heading. */
export function RequireLearner({ children }: { children: ReactNode }): JSX.Element {
  const { signedIn, ready, resolving } = useLearner();
  const location = useLocation();

  // Waiting for storage — render nothing rather than flashing the sign-up page.
  if (!ready) return <div className="route-loading" aria-busy="true" />;

  /*
   * Waiting for the server.
   *
   * A returning learner signing in on a new device has nothing in local
   * storage: their profile is still arriving. Redirecting here would send
   * somebody with months of progress to "create a learner", which is both
   * alarming and wrong.
   */
  if (resolving) return <div className="route-loading" aria-busy="true" />;

  if (!signedIn) return <Navigate to="/start" replace state={{ from: location.pathname }} />;

  return <>{children}</>;
}
